<template>
    <div>
        <b-button
            :to="{ name:'create-category'}"
            class="mb-1 mr-1"
            variant="relief-primary"
        >
            {{ $t('new') }}
        </b-button>
        <b-button
            class="mb-1"
            variant="info"
            @click="visible = !visible"
        >
            {{ $t('search') }}
        </b-button>
        <custom-filter
            :filters="filters"
            :visible="visible"
            @onSubmit="filters => filter(filters)"
        >
            <template #form="{filters}">
                <b-row>
                    <b-col md="6">
                        <custom-input
                            v-model="filters.name"
                            :name="$t('name')"
                            vid="name"
                        />
                    </b-col>
                    <b-col md="6">
                        <custom-input
                            v-model="filters.name_en"
                            :name="$t('name_en')"
                            vid="name"
                        />
                    </b-col>
                    <b-col md="6">
                        <custom-select
                            v-model="filters.status"
                            :name="$t('status')"
                            :options="categoryStatusOptions"
                            vid="status"
                        >
                            <template #first>
                                <b-form-select-option :value="null"/>
                            </template>
                        </custom-select>
                    </b-col>
                </b-row>
            </template>
        </custom-filter>
        <b-card no-body>
            <b-table
                :busy="status === 'LOADING'"
                :fields="fields"
                :items="Object.values(categories)"
                hover
                responsive
            >
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"/>
                    </div>
                </template>
                <template #cell(status)="data">
                    <b-badge :variant="statusColor(data.item.status)">
                        {{ statusText(data.item.status) }}
                    </b-badge>
                </template>
                <template #cell(action)="data">
                    <b-dropdown
                        no-caret
                        variant="link"
                    >
                        <template #button-content>
                            <feather-icon icon="MoreHorizontalIcon"/>
                        </template>
                        <b-dropdown-item :to="{name: 'edit-category', params:{id: data.item.id}}">
                            <feather-icon icon="Edit2Icon"/>
                            {{ $t('edit') }}
                        </b-dropdown-item>
                        <b-dropdown-item @click="confirmDelete(data.item.id)">
                            <feather-icon icon="XIcon"/>
                            {{ $t('delete') }}
                        </b-dropdown-item>
                    </b-dropdown>
                </template>
            </b-table>
            <b-pagination
                v-if="pagination.last_page > 1"
                v-model="pagination.current_page"
                :per-page="pagination.per_page"
                :total-rows="pagination.total"
                align="center"
                class="mt-2"
                @change="paginationCategory"
            />
        </b-card>
    </div>
</template>

<script>
import fields from "./partials/fields";
import { mapActions, mapGetters } from "vuex";
import CategoryStatus from "@/constans/CategoryStatus";
import { categoryStatusOptions } from "@/common/data";
import { BFormSelectOption } from "bootstrap-vue";

export default {
    name: 'Categories',

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchCategories()
        })
    },

    components: {
        BFormSelectOption
    },

    data() {
        return {
            fields,
            visible: false,
            filters: {
                name: '',
                name_en: '',
                status: '',
            },
            categoryStatusOptions
        }
    },

    computed: {
        ...mapGetters('category', [
            'categories', 'status', 'pagination'
        ]),
        ...mapGetters('filter', [
            'filterFields'
        ])
    },

    methods: {
        ...mapActions({
            fetchCategories: 'category/fetch',
            deleteCategory: 'category/delete'
        }),
        filter(filters) {
            this.fetchCategories({
                ...filters,
                page: 1
            })
        },
        paginationCategory(page) {
            this.fetchCategories({
                page,
                ...this.filterFields
            })
        },
        confirmDelete(id) {
            this.$swal({
                title: this.$t('Are you sure?'),
                text: this.$t("You won't be able to revert this!"),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('Yes, delete it!'),
                cancelButtonText: this.$t('No'),
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-danger ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    this.deleteCategory(id).then(() => {
                        this.$swal({
                            icon: 'success',
                            title: this.$t(`Deleted!`),
                            text: this.$t('Your file has been deleted.'),
                            confirmButtonText: this.$t('Ok!'),
                            customClass: {
                                confirmButton: 'btn btn-success',
                            },
                        })
                    })
                }
            })
        },
        statusColor(value) {
            return value === CategoryStatus.INACTIVE ? 'warning' : 'primary'
        },
        statusText(value) {
            if (value === CategoryStatus.INACTIVE) return this.$t('category.status.in_active')
            if (value === CategoryStatus.ACTIVE) return this.$t('category.status.active')
        },

    }
}
</script>
